import { render, staticRenderFns } from "./sincroOnline.vue?vue&type=template&id=cc6a5142"
import script from "./sincroOnline.vue?vue&type=script&lang=js"
export * from "./sincroOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports